// extracted by mini-css-extract-plugin
module.exports = {"indicator":"MarkIndicator__indicator___z8HcZ"};